import React from "react";
import PropTypes from "prop-types";
import { Box, Chip } from "@mui/material";
import { getSkillBadgeColorSet } from "../../../../constants/colors";

const keywordShape = PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  name: PropTypes.string,
});

FilterTag.propTypes = {
  selectedKeywords: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, keywordShape])
  ),
  onDeleteTag: PropTypes.func,
  type: PropTypes.string,
};

export default function FilterTag({ selectedKeywords = [], onDeleteTag = () => {}, type = "project", }) {
  const colors = getSkillBadgeColorSet(type);

  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      {selectedKeywords.map((keyword, keywordIndex) => (
        <Chip
          key={
            typeof keyword === "string"
            ? (keyword ? `keyword-${keywordIndex}-${keyword}` : `keyword-${keywordIndex}`)
            : (
              keyword.key ??
              keyword.id ??
              (
                (keyword.label ?? keyword.name)
                  ? `${keyword.label ?? keyword.name}-${keywordIndex}`
                  : `key-${keywordIndex}`
              )
            )
          }
          label={typeof keyword === "string" ? keyword : (keyword.label ?? keyword.name)}
          onDelete={() => onDeleteTag(keywordIndex)}
          sx={{
            bgcolor: colors.bgDefault,
            color: colors.textStrong,
            border: colors.border,
            fontWeight: 600,

            "& .MuiChip-deleteIcon": {
              color: colors.textStrong,
              opacity: 0.7,
            },
          }}
        />
      ))}
    </Box>
  );
}